import { types, actions } from './requests'
export const GETWORKLISTFORDAY_TYPES = {
    ...types('GETWORKLISTFORDAY'),
}
export const GETWORKLISTFORDAY_ACTIONS = {
    ...actions('GETWORKLISTFORDAY'),
}
